import { offerTypes as actionTypes } from '@actions';
import { commonState, commonReducer, pagination } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default(),
};

const collectionState = {
  ...commonState.default({ collection: true }),
  pagination,
};

export const offerList = (state = collectionState, action) =>
  commonReducer(actionTypes.LIST, state, action);

export const offerSearch = (state = collectionState, action) =>
  commonReducer(actionTypes.SEARCH, state, action);

export const offerCurrent = (state = defaultState, action) =>
  commonReducer(actionTypes.GET, state, action);
